import {Tag} from 'folder-items/FileConstants';

export enum TagsReduxActions {
  INITIAL_TAGS_SET = 'INITIAL_TAGS_SET',
  TAG_UPDATED = 'TAG_UPDATED',
  CONNECTION_UPDATED = 'CONNECTION_UPDATED',
  EQUIPMENT_UPDATED = 'EQUIPMENT_UPDATED',
  STUDIES_UPDATED = 'STUDIES_UPDATED',
  TAGS_RESET = 'TAGS_RESET',
}

export interface InitialTagsSetAction {
  type: TagsReduxActions.INITIAL_TAGS_SET;
  cid: string;
  tags: Array<Tag>;
  connectionId: string | null;
  equipmentId: string | null;
  studyIds: Array<string>;
}

export function initialTagsSet(
  cid: string,
  tags: Array<Tag>,
  connectionId: string | null,
  equipmentId: string | null,
  studyIds: Array<string>
): InitialTagsSetAction {
  return {
    type: TagsReduxActions.INITIAL_TAGS_SET,
    cid,
    tags,
    connectionId,
    equipmentId,
    studyIds,
  };
}

export interface TagUpdatedAction {
  type: TagsReduxActions.TAG_UPDATED;
  cid: string;
  tagIndex: number;
  tag: Tag;
}

export function tagUpdated(cid: string, tagIndex: number, tag: Tag): TagUpdatedAction {
  return {
    type: TagsReduxActions.TAG_UPDATED,
    cid,
    tagIndex,
    tag,
  };
}

export interface ConnectionUpdatedAction {
  type: TagsReduxActions.CONNECTION_UPDATED;
  cid: string;
  connectionId: string | null;
}

export function connectionUpdated(cid: string, connectionId: string | null): ConnectionUpdatedAction {
  return {
    type: TagsReduxActions.CONNECTION_UPDATED,
    cid,
    connectionId,
  };
}

export interface EquipmentUpdatedAction {
  type: TagsReduxActions.EQUIPMENT_UPDATED;
  cid: string;
  equipmentId: string | null;
  connectionId?: string | null;
}

export function equipmentUpdated(
  cid: string,
  equipmentId: string | null,
  connectionId?: string | null
): EquipmentUpdatedAction {
  return {
    type: TagsReduxActions.EQUIPMENT_UPDATED,
    cid,
    equipmentId,
    connectionId,
  };
}

export interface StudiesUpdatedAction {
  type: TagsReduxActions.STUDIES_UPDATED;
  cid: string;
  studyIds: Array<string>;
}

export function studiesUpdated(cid: string, studyIds: Array<string>): StudiesUpdatedAction {
  return {
    type: TagsReduxActions.STUDIES_UPDATED,
    cid,
    studyIds,
  };
}

export interface TagsResetAction {
  type: TagsReduxActions.TAGS_RESET;
  cid: string;
}

export function tagsReset(cid: string): TagsResetAction {
  return {
    type: TagsReduxActions.TAGS_RESET,
    cid,
  };
}

export type TagsAction =
  | ConnectionUpdatedAction
  | EquipmentUpdatedAction
  | InitialTagsSetAction
  | StudiesUpdatedAction
  | TagUpdatedAction
  | TagsResetAction;
